<div class="mt-4 mx-4">

    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

    <!-- ── Tabs ──────────────────────────────────────────────────── -->
    <ul class="nav nav-tabs d-flex" role="tablist">
        <li class="nav-item flex-fill text-center" role="presentation">
            <button class="nav-link w-100" [class.active]="activeTab==='approved'" (click)="setActiveTab('approved')"
                type="button">
                Approved Payments
            </button>
        </li>
        <li class="nav-item flex-fill text-center" role="presentation">
            <button class="nav-link w-100" [class.active]="activeTab==='pending'" (click)="setActiveTab('pending')"
                type="button">
                Pending Approval
                <span class="badge bg-danger ms-1">{{ pendingPaymentTotalCount }}</span>
            </button>
        </li>
        <li class="nav-item flex-fill text-center" role="presentation">
            <button class="nav-link w-100" [class.active]="activeTab==='rejected'" (click)="setActiveTab('rejected')"
                type="button">
                Rejected Payments
            </button>
        </li>
    </ul>

    <!-- ── Tab content ───────────────────────────────────────────── -->
    <div class="tab-content mt-3">

        <!-- ── Approved ────────────────────────────────────────────── -->
        <ng-container *ngTemplateOutlet="companiesPanel; context:{
        tab: 'approved',
        icon: 'bi-check-circle',
        title: 'Approved Payments',
        subtitle: 'Select a company to view approved payments.',
        companies: filteredApprovedCompanies,
        paged: pagedApprovedCompanies,
        loading: isApprovedLoading,
        error: approvedError
      }"></ng-container>

        <!-- ── Pending ─────────────────────────────────────────────── -->
        <ng-container *ngTemplateOutlet="companiesPanel; context:{
        tab: 'pending',
        icon: 'bi-clock-history',
        title: 'Pending Approval',
        subtitle: 'Select a company to view payments awaiting approval.',
        companies: filteredPendingCompanies,
        paged: pagedPendingCompanies,
        loading: isPendingLoading,
        error: pendingError
      }"></ng-container>

        <!-- ── Rejected ────────────────────────────────────────────── -->
        <ng-container *ngTemplateOutlet="companiesPanel; context:{
        tab: 'rejected',
        icon: 'bi-x-circle',
        title: 'Rejected Payments',
        subtitle: 'Select a company to view rejected payments.',
        companies: filteredRejectedCompanies,
        paged: pagedRejectedCompanies,
        loading: isRejectedLoading,
        error: rejectedError
      }"></ng-container>

    </div>
</div>

<!-- ── Reusable companies panel template ─────────────────────────── -->
<ng-template #companiesPanel let-tab="tab" let-icon="icon" let-title="title" let-subtitle="subtitle"
    let-companies="companies" let-paged="paged" let-loading="loading" let-error="error">

    <div class="tab-pane fade" [class.show]="activeTab===tab" [class.active]="activeTab===tab">
        <div class="card shadow-sm border-0">
            <div class="card-body">

                <!-- Header info bar -->
                <div class="row mb-2">
                    <div class="col-12">
                        <div class="p-3 rounded-3 border bg-light">
                            <div class="small text-muted d-flex align-items-center gap-2">
                                <i class="bi {{ icon }}"></i> {{ title }}
                            </div>
                            <div class="text-muted small mt-1">{{ subtitle }}</div>
                        </div>
                    </div>
                </div>

                <!-- Search -->
                <div class="row g-3 align-items-end mb-3 mt-2">
                    <div class="col-md-12">
                        <label class="label-text">Search Companies</label>
                        <div class="position-relative">
                            <input type="text" class="form-control user-search-input shadow-none"
                                placeholder="Type here..." [ngModel]="getSearchText(tab)"
                                (ngModelChange)="tab==='approved' ? approvedSearchText=$event : tab==='pending' ? pendingSearchText=$event : rejectedSearchText=$event; applySearch(tab)" />
                            <span class="search-icon"><i class="bi bi-search"></i></span>
                        </div>
                    </div>
                </div>

                <!-- Loading -->
                <div *ngIf="loading" class="text-muted">Loading companies...</div>

                <!-- Empty / Error -->
                <div *ngIf="!loading && (error || companies.length === 0)" class="text-center py-5">
                    <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
                    <p class="text-muted">{{ error || 'No companies found.' }}</p>
                </div>

                <!-- Companies table -->
                <div *ngIf="companies.length > 0 && !error" class="table-responsive-wrapper">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width:48px;"></th>
                                <th class="table-title text-start">Company Name</th>
                                <th class="table-title text-start">Company ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let company of paged">

                                <!-- Company row -->
                                <tr class="clickable-row" (click)="toggleExpand(tab, company)">
                                    <td>
                                        <button class="btn p-0" style="background:none;border:none;"
                                            (click)="$event.stopPropagation(); toggleExpand(tab, company)">
                                            <i class="bi" style="font-size:1.05rem;color:var(--primary-color);"
                                                [ngClass]="isExpanded(tab, company.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                                        </button>
                                    </td>
                                    <td class="table-data-text text-start">{{ company.companyName }}</td>
                                    <td class="table-data-text text-start">{{ company.companyId }}</td>
                                </tr>

                                <!-- Expanded payments row -->
                                <tr *ngIf="isExpanded(tab, company.companyId)">
                                    <td></td>
                                    <td colspan="2">
                                        <div class="p-3 rounded-3 border bg-light">
                                            <div class="d-flex align-items-center justify-content-between mb-2">
                                                <div class="small text-muted d-flex align-items-center gap-2">
                                                    <i class="bi bi-receipt"></i> Invoices
                                                </div>
                                                <span *ngIf="isPaymentsLoading(tab, company.companyId)"
                                                    class="small text-muted">Loading…</span>
                                                <span *ngIf="paymentsError(tab, company.companyId)"
                                                    class="small text-danger">
                                                    {{ paymentsError(tab, company.companyId) }}
                                                </span>
                                                <span *ngIf="!isPaymentsLoading(tab, company.companyId)
                                                            && !paymentsError(tab, company.companyId)
                                                            && getPaymentsFor(tab, company.companyId).length === 0"
                                                    class="small text-muted">No invoices found.</span>
                                            </div>

                                            <div *ngIf="getPaymentsFor(tab, company.companyId).length > 0"
                                                class="table-responsive-wrapper">
                                                <table class="table table-bordered mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="table-title text-start">Invoice No.</th>
                                                            <th class="table-title text-start">Status</th>
                                                            <th class="table-title text-end">Invoice Amount (LKR)</th>
                                                            <th class="table-title text-start">Created Date</th>
                                                            <th class="table-title text-center" style="width:48px;">
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let p of getPaymentsFor(tab, company.companyId)">
                                                            <td class="table-data-text text-start">{{
                                                                p.payRollInvoiceNumber }}</td>
                                                            <td class="table-data-text text-start">
                                                                <span class="badge" [ngClass]="{
                                                                    'bg-success': p.statusId === 3,
                                                                    'bg-warning text-dark': p.statusId === 1,
                                                                    'bg-secondary': p.statusId === 2,
                                                                    'bg-danger': p.statusId === 4
                                                                    }">
                                                                    {{ p.statusDescription }}
                                                                </span>
                                                            </td>
                                                            <td class="table-data-text text-end">{{ (p.invoiceAmount) |
                                                                number:'1.2-2' }}</td>
                                                            <td class="table-data-text text-start">{{ p.createdDate |
                                                                date:'yyyy-MM-dd HH:mm a' }}</td>
                                                            <td class="table-data-text text-center">
                                                                <button class="btn p-0"
                                                                    style="background:none;border:none;"
                                                                    (click)="$event.stopPropagation(); openDetail(company, p)"
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#payrollDetailsOffcanvas">
                                                                    <i class="bi bi-arrow-right"
                                                                        style="font-size:1.1rem;color:var(--primary-color);"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </ng-container>
                        </tbody>
                    </table>

                    <app-paginator [dataSource]="companies" [pageSize]="10" [pageSizeOptions]="[5,10,20,50]"
                        (pageChange)="onPageChange(tab, $event)">
                    </app-paginator>
                </div>

            </div>
        </div>
    </div>
</ng-template>

<!-- ── Offcanvas: Payment Details ─────────────────────────────────── -->
<div class="offcanvas offcanvas-end w-70" tabindex="-1" id="payrollDetailsOffcanvas"
    aria-labelledby="payrollDetailsOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

    <div class="offcanvas-header">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-10 d-flex align-items-center">
                    <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="payrollDetailsOffcanvasLabel">
                        <i class="bi bi-cash-stack fs-5"></i>
                        Payroll Invoice Details
                        <span class="ms-2 text-muted small" *ngIf="selectedCompany">
                            — {{ selectedCompany.companyName }}
                        </span>
                    </h5>
                </div>
                <div class="col-2 text-end">
                    <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"
                        aria-label="Close"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas-body">

        <!-- Loading -->
        <div *ngIf="isDetailLoading" class="text-muted py-4 text-center">
            <span class="spinner-border spinner-border-sm me-2"></span> Loading details...
        </div>

        <!-- Error -->
        <div *ngIf="!isDetailLoading && detailError" class="alert alert-danger rounded-3 border-0">
            <i class="bi bi-exclamation-triangle me-2"></i> {{ detailError }}
        </div>

        <!-- Detail content -->
        <div *ngIf="!isDetailLoading && !detailError && paymentDetail">

            <!-- Invoice Information -->
            <div class="card mb-4 border rounded-4 overflow-hidden">
                <div class="card-header bg-white border-bottom py-3 px-4">
                    <h6 class="mb-0 fw-bold text-dark">Invoice Information</h6>
                </div>
                <div class="card-body p-4 bg-light">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <small class="text-secondary d-block mb-1">Invoice Number</small>
                            <code class="text-dark bg-white px-2 py-1 rounded">{{ paymentDetail.payRollInvoiceNumber || '-' }}</code>
                        </div>
                        <div class="col-md-6">
                            <small class="text-secondary d-block mb-1">Status</small>
                            <span class="badge fs-6" [ngClass]="{
                                    'bg-success': paymentDetail.statusId === 3,
                                    'bg-warning text-dark': paymentDetail.statusId === 1,
                                    'bg-secondary': paymentDetail.statusId === 2,
                                    'bg-danger': paymentDetail.statusId === 4
                                }">
                                {{ paymentDetail.statusDescription }}
                            </span>
                        </div>
                        <div class="col-md-6">
                            <small class="text-secondary d-block mb-1">Uploaded Slip Version</small>
                            <span class="fw-semibold text-dark">{{ paymentDetail.versionNumber }}</span>
                        </div>
                        <div class="col-md-6">
                            <small class="text-secondary d-block mb-1">Created Date</small>
                            <span class="fw-semibold text-dark">{{ paymentDetail.createdDate | date:'yyyy-MM-dd HH:mm a'
                                }}</span>
                        </div>
                        <div class="col-md-6" *ngIf="paymentDetail.authorizedDate">
                            <small class="text-secondary d-block mb-1">Authorized Date</small>
                            <span class="fw-semibold text-dark">{{ paymentDetail.authorizedDate | date:'yyyy-MM-dd HH:mm a' }}</span>
                        </div>
                        <!-- <div class="col-md-6" *ngIf="paymentDetail.authorizedBy">
                            <small class="text-secondary d-block mb-1">Authorized By</small>
                            <span class="fw-semibold text-dark">{{ paymentDetail.authorizedBy }}</span>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- Amount Information -->
            <div class="card mb-4 border rounded-4 overflow-hidden">
                <div class="card-header bg-white border-bottom py-3 px-4">
                    <h6 class="mb-0 fw-bold text-dark">Amount Information</h6>
                </div>
                <div class="card-body p-4 bg-white">
                    <div class="text-center p-3 bg-light rounded-3">
                        <small class="text-secondary d-block mb-2">Invoice Amount</small>
                        <h4 class="mb-0 fw-bold text-dark">{{ (paymentDetail.invoiceAmount) | number:'1.2-2' }}
                        </h4>
                        <small class="text-muted">LKR</small>
                    </div>
                </div>
            </div>

            <!-- Payment Slip -->
            <div class="card mb-4 border rounded-4 overflow-hidden" *ngIf="paymentDetail.paySlipBlobUrl">
            
                <!-- Header -->
                <div class="card-header bg-white border-bottom py-3 px-4 d-flex align-items-center justify-content-between">
                    <h6 class="mb-0 fw-bold text-dark d-flex align-items-center gap-2">
                        <i class="bi" [ngClass]="slipIsPdf ? 'bi-file-earmark-pdf text-danger' : 'bi-image text-primary'">
                        </i>
                        Payment Slip
                    </h6>
            
                    <!-- Actions (visible only after slip is loaded) -->
                    <!-- <div class="d-flex gap-2" *ngIf="slipObjectUrl">
                        <button class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                            (click)="openSlipInNewTab()" title="Open in new tab">
                            <i class="bi bi-box-arrow-up-right"></i> Open
                        </button>
                        <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                            (click)="reDownloadSlip(paymentDetail.companyId, paymentDetail.payRollInvoiceNumber, paymentDetail.versionNumber, paymentDetail.createdDate)"
                            title="Download again">
                            <i class="bi bi-download"></i> Download
                        </button>
                    </div> -->
                </div>
            
                <div class="card-body p-3 bg-white">
            
                    <!-- ── State 1: Not yet loaded ── -->
                    <div *ngIf="!slipObjectUrl && !isSlipLoading && !slipLoadError" class="text-center py-4">
                        <div class="mb-3 text-muted">
                            <i class="bi bi-file-earmark-arrow-down" style="font-size: 2.5rem;"></i>
                        </div>
                        <p class="text-muted small mb-3">
                            Click below to load and download the payment slip.
                        </p>
                        <button class="btn btn-primary d-inline-flex align-items-center gap-2" (click)="loadPaymentSlip(
                            paymentDetail.paySlipBlobUrl,
                            paymentDetail.companyId,
                            paymentDetail.payRollInvoiceNumber,
                            paymentDetail.versionNumber,
                            paymentDetail.createdDate)">
                            <i class="bi bi-cloud-download"></i>
                            Load &amp; Download Slip
                        </button>
                    </div>
            
                    <!-- ── State 2: Error ── -->
                    <div *ngIf="slipLoadError && !isSlipLoading" class="text-center py-4">
                        <i class="bi bi-exclamation-triangle text-danger mb-2" style="font-size: 2rem;"></i>
                        <p class="text-danger small mb-3">{{ slipLoadError }}</p>
                        <button class="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1" (click)="loadPaymentSlip(
                            paymentDetail.paySlipBlobUrl,
                            paymentDetail.companyId,
                            paymentDetail.payRollInvoiceNumber,
                            paymentDetail.versionNumber,
                            paymentDetail.createdDate)">
                            <i class="bi bi-arrow-clockwise"></i> Retry
                        </button>
                    </div>
            
                    <!-- ── State 3a: Loaded — Image preview ── -->
                    <ng-container *ngIf="slipObjectUrl && !slipIsPdf && !isSlipLoading">
                        <div class="text-center">
                            <img [src]="slipObjectUrl" alt="Payment Slip" class="img-fluid rounded-3 border"
                                style="max-height: 520px; cursor: zoom-in; object-fit: contain;" (click)="openSlipInNewTab()"
                                title="Click to view full size">
                            <p class="text-muted small mt-2 mb-0">
                                <i class="bi bi-zoom-in me-1"></i>Click image to view full size
                            </p>
                        </div>
                    </ng-container>
            
                    <!-- ── State 3b: Loaded — PDF (no inline preview — show info card) ── -->
                    <ng-container *ngIf="slipObjectUrl && slipIsPdf && !isSlipLoading">
                        <div class="p-4 rounded-3 bg-light border d-flex align-items-center gap-4">
                            <div class="flex-shrink-0">
                                <i class="bi bi-file-earmark-pdf text-danger" style="font-size: 3.5rem;"></i>
                            </div>
                            <div class="flex-grow-1 text-start">
                                <p class="mb-1 fw-semibold text-dark">PDF Downloaded Successfully</p>
                                <p class="mb-0 text-muted small">
                                    {{ paymentDetail.payRollInvoiceNumber }} &bull;
                                    Version {{ paymentDetail.versionNumber }} &bull;
                                    {{ paymentDetail.createdDate | date:'yyyy-MM-dd' }}
                                </p>
                            </div>
                            <div class="d-flex flex-column gap-2">
                                <button class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                                    (click)="openSlipInNewTab()">
                                    <i class="bi bi-box-arrow-up-right"></i> Open
                                </button>
                                <button class="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                    (click)="reDownloadSlip(paymentDetail.companyId, paymentDetail.payRollInvoiceNumber, paymentDetail.versionNumber, paymentDetail.createdDate)">
                                    <i class="bi bi-download"></i>Download Again
                                </button>
                            </div>
                        </div>
                    </ng-container>
            
                </div>
            </div>

            <!-- Action Buttons — Pending tab only -->
            <div class="d-flex gap-2 justify-content-end mt-4" *ngIf="activeTab === 'pending'">
                <button class="btn btn-outline-danger" [disabled]="isRejecting || isApproving"
                    (click)="openRejectModal()" *ngIf="authService.canReview('manageCixorPayments.payrollPayments')">
                    <i class="bi bi-x-circle me-1"></i> Reject
                </button>
                <button class="btn btn-success" [disabled]="isApproving || isRejecting" (click)="approvePayment()"
                    *ngIf="authService.canReview('manageCixorPayments.payrollPayments')">
                    <span *ngIf="!isApproving"><i class="bi bi-check-circle me-1"></i> Approve</span>
                    <span *ngIf="isApproving">
                        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                        Approving...
                    </span>
                </button>
            </div>

        </div>
    </div>
</div>

<!-- ── Reject Confirmation Modal (no reason field) ────────────────── -->
<div class="modal fade" id="payrollRejectModal" tabindex="-1" aria-labelledby="payrollRejectModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="payrollRejectModalLabel">
                    <i class="bi bi-exclamation-triangle text-danger me-2"></i>
                    Reject Payment
                </h5>
                <button type="button" class="btn-close" (click)="closeRejectModal()" [disabled]="isRejecting"
                    aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <p class="mb-1">Are you sure you want to reject this payroll payment?</p>
                <p class="text-muted small mb-0" *ngIf="selectedPayment">
                    Invoice: <strong>{{ selectedPayment.payRollInvoiceNumber }}</strong> &mdash;
                    Amount: <strong>{{ (selectedPayment.invoiceAmount) | number:'1.2-2' }} LKR</strong>
                </p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeRejectModal()" [disabled]="isRejecting">
                    Cancel
                </button>
                <button type="button" class="btn btn-danger" (click)="confirmReject()" [disabled]="isRejecting">
                    <span *ngIf="!isRejecting"><i class="bi bi-x-circle me-1"></i> Confirm Reject</span>
                    <span *ngIf="isRejecting">
                        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                        Rejecting...
                    </span>
                </button>
            </div>

        </div>
    </div>
</div>